import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@getro/rombo';

export const TagItem = memo(({ selected, onRemove, onAdd, option, variant }) => {
  const toggle = () => (selected ? onRemove() : onAdd());

  return (
    <Tag
      data-testid={`tag${`-${option.id}`}${selected ? '-selected' : ''}`}
      variant={selected ? `${variant}Accent` : variant}
      onClick={toggle}
      sx={{ border: 'none' }}
    >
      {option.label || option.name}
    </Tag>
  );
});

TagItem.propTypes = {
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  option: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

TagItem.defaultProps = {
  variant: 'default',
};
